import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api, tokens } from '../api/client';
import { MarcaLogin } from '../layout/Logo';

/**
 * Conclusão do convite: rota pública, porque o token do link É a credencial.
 *
 * Ao final a pessoa já entra logada — o backend devolve o par de tokens, e
 * obrigar a digitar a senha recém-criada seria atrito sem ganho.
 */
export function AceitarConvite() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';

  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function submeter(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setErro(null);

    const dados = new FormData(e.currentTarget);
    const senha = String(dados.get('senha'));

    if (senha !== String(dados.get('confirmacao'))) {
      setErro('As senhas não conferem.');
      return;
    }

    setEnviando(true);

    try {
      const resposta = await api<{ accessToken: string; refreshToken: string }>(
        '/auth/accept-invite',
        { method: 'POST', body: { token, password: senha }, semRenovacao: true },
      );

      tokens.salvar(resposta.accessToken, resposta.refreshToken);
      // Recarrega em vez de navegar: o AuthProvider lê a sessão na montagem, e
      // esta rota vive fora dele.
      window.location.href = '/';
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Não foi possível concluir o convite.');
      setEnviando(false);
    }
  }

  if (!token) {
    return (
      <div className="login-tela">
        <div className="login-caixa">
          <MarcaLogin />
          <div className="login-titulo">Link incompleto</div>
          <p style={{ fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.55 }}>
            Este endereço não tem o código do convite. Use o link completo que você recebeu, ou
            peça um novo ao administrador.
          </p>
          <Link className="btn btn-secondary login-botao" to="/entrar" style={{ marginTop: 18 }}>
            Ir para o login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="login-tela">
      <div className="login-caixa">
        <MarcaLogin />

        <div className="login-titulo">Defina sua senha para começar</div>

        <form onSubmit={submeter}>
          {erro && <div className="form-erro">{erro}</div>}

          <label className="campo">
            <span className="campo-label">Nova senha</span>
            <input
              className="login-input"
              name="senha"
              type="password"
              autoComplete="new-password"
              minLength={10}
              required
              autoFocus
            />
            <span className="campo-ajuda">Mínimo de 10 caracteres.</span>
          </label>

          <label className="campo">
            <span className="campo-label">Confirme a senha</span>
            <input
              className="login-input"
              name="confirmacao"
              type="password"
              autoComplete="new-password"
              minLength={10}
              required
            />
          </label>

          <button
            className="btn btn-primary login-botao"
            type="submit"
            disabled={enviando}
            style={{ marginTop: 8 }}
          >
            {enviando ? 'Definindo…' : 'Definir senha e entrar'}
          </button>
        </form>

        <hr className="login-divisor" />

        <div className="login-rodape">O convite vale uma única vez e expira em 7 dias.</div>
      </div>
    </div>
  );
}
